/**
 * Low level API for sending the HTTPS request.
 * @param {Request} request
 * @returns {Promise<Response>}
 */
export function sendRequest(request) {
	return fetch(request);
}
